export default __webpack_public_path__ + "static/top_reviewaid-42b07d3f3496b33825b5b5a5718f01fa.png";